import MessageCircleWhatsappIcon from '@components/v2/icons/MessageCircleWhatsapp';
import ErrorScreen from '@components/v2/layout/ErrorScreen/ErrorScreen';
import ServerErrorIllustration from '@components/v2/layout/ErrorScreen/svg/ServerErrorIllustration';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Stack } from '@mui/material';
import { LogOut, RefreshCw } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { whatsapp } from '../../../../utils/constants';
import { getWhatsAppLink } from '../../../customer/utils/customer.utils';
import { OUR_BRAND_NAME } from '../../../reports/utils/consts';
import { useTranslation } from '../../../translation/TranslationContext';
import useServerErrorPage from './hooks/useServerErrorPage';

const FOOTER_GAP = 1;

const ServerErrorPage = () => {
  const { translate } = useTranslation();
  const { counter, isRetryingAutomatically, retry, logout } = useServerErrorPage();

  const retryAction = isRetryingAutomatically
    ? {
        label: LangEnum.SERVER_ERROR_RETRYING_IN_MESSAGE,
        labelValues: { quantity: counter },
        icon: RefreshCw,
        disabled: true,
      }
    : { label: LangEnum.GLOBAL_RETRY, icon: RefreshCw, onClick: retry };

  return (
    <ErrorScreen
      title={{ text: LangEnum.GLOBAL_SOMETHING_WENT_WRONG }}
      description={{ text: LangEnum.SERVER_ERROR_FAILED_LOAD_INFORMATION_MESSAGE }}
      illustration={<ServerErrorIllustration />}
      actions={{ primary: retryAction }}
      slots={{
        footer: (
          <Stack direction="row" sx={{ gap: FOOTER_GAP }}>
            <Button
              variant="contained"
              color="secondary"
              size="medium"
              startIcon={<Icon icon={LogOut} size="sm" />}
              onClick={logout}
            >
              {translate(LangEnum.SERVER_ERROR_FORCE_LOGOUT_MESSAGE)}
            </Button>

            <Button
              variant="contained"
              color="secondary"
              size="medium"
              href={getWhatsAppLink({ phone: whatsapp.phoneWithoutDDI })}
              endIcon={<Icon icon={MessageCircleWhatsappIcon} size="sm" />}
            >
              {translate(LangEnum.GLOBAL_TALK_TO_BRAND, { brand: OUR_BRAND_NAME })}
            </Button>
          </Stack>
        ),
      }}
    />
  );
};

export default ServerErrorPage;
